var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowCareer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4803",
    "data-name": "Group 4803",
    transform: "translate(-0.191 -0.096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(0.191 0.096)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M3.554,0a.154.154,0,0,0-.11.045l-3.4,3.4a.155.155,0,1,0,.219.218L3.554.373l3.29,3.29a.154.154,0,0,0,.218-.218l-3.4-3.4A.155.155,0,0,0,3.554,0Z",
    transform: "translate(16.606 9.895) rotate(90)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowCareer);
export default __webpack_public_path__ + "static/media/right-arrow-career.c569525eae83141b68274f24539190c9.svg";
export { ForwardRef as ReactComponent };